import UserLogin from './components/UserLogin.vue';
import PasswordReset from './components/PasswordReset.vue';
import PasswordSet from './components/PasswordSet.vue';
import RegistrationForm from './components/RegistrationForm.vue';
import Auth from './plugins/auth.js';
import AuthApi from './services/api/auth.js';
import canHaveCustomersPageMixin from './mixins/canHaveCustomersPage.js';

export {
    UserLogin,
    PasswordReset,
    PasswordSet,
    RegistrationForm,
    Auth,
    AuthApi,
    canHaveCustomersPageMixin
};
